export const BUTTON_TYPE = {
  delete: 'delete',
  acceptMultipleMonths: 'acceptMultipleMonths',
  rejectAbsenceRequest: 'rejectAbsenceRequest',
  displayAbsencePlannerDrawer: 'displayAbsencePlannerDrawer',
} as const
